<template lang="pug">
  course-list(
    title="Курсы, где я преподаю"
    :params="{\
      'search[teacher]': userData.id\
    }"
  )
</template>

<script>
import { mapGetters } from 'vuex';
import CourseList from '../components/CourseList.vue';

export default {
  components: {
    CourseList,
  },
  computed: {
    ...mapGetters({ userData: 'auth/userData' }),
  },
};
</script>
